import { Grid, TextField, Typography } from '@material-ui/core';
import { useContext } from 'react';
import EditDataSpaceFormContext from '../../context/EditDataSpaceFormContext';

const NameDataSpaceInput = () => {
	const editDataSpaceFormContext = useContext(EditDataSpaceFormContext);

	const dataSpaceNameInputChangeHandler = (e) => {
		editDataSpaceFormContext.setDataSpace((prevState) => ({
			...prevState,
			name: e.target.value,
		}));
	};

	return (
		<Grid item container xs={12}>
			<Grid item xs={12}>
				<Typography variant="h6" align="left">
					Name your DataSpace
				</Typography>
			</Grid>

			<Grid item xs={12}>
				<TextField
					onChange={dataSpaceNameInputChangeHandler}
					value={editDataSpaceFormContext.dataSpace.name}
					autoFocus
					margin="dense"
					id="name"
					label="Name"
					type="text"
					fullWidth
					InputLabelProps={{ shrink: true }}
				/>
			</Grid>
		</Grid>
	);
};

export default NameDataSpaceInput;
